// @ts-nocheck
import {
  createIntl,
  IntlShape,
  MessageDescriptor,
} from '/app/node_modules/react-intl';
import { ApplyPluginsType } from 'umi';
import { event, LANG_CHANGE_EVENT } from './locale';
// @ts-ignore
import warning from '/app/node_modules/@umijs/plugin-locale/node_modules/warning/warning.js';

import { plugin } from '../core/plugin';

export {
  createIntl,
};
export {
  FormattedDate,
  FormattedDateParts,
  FormattedDisplayName,
  FormattedHTMLMessage,
  FormattedList,
  FormattedMessage,
  FormattedNumber,
  FormattedNumberParts,
  FormattedPlural,
  FormattedRelativeTime,
  FormattedTime,
  FormattedTimeParts,
  IntlContext,
  IntlProvider,
  RawIntlProvider,
  createIntlCache,
  defineMessages,
  injectIntl,
  useIntl,
} from '/app/node_modules/react-intl';

let g_intl: IntlShape;

const useLocalStorage = true;

import enUS0 from 'antd/es/locale/en_US';
import lang_enUS0 from "/app/src/locales/en-US.ts";
import zhCN0 from 'antd/es/locale/zh_CN';
import lang_zhCN0 from "/app/src/locales/zh-CN.ts";
import lang_zhCN1 from "/app/src/pages/AnnouncementRecordDetailPage/locales/zh-CN.ts";
import lang_zhCN2 from "/app/src/pages/AnnouncementRecordListPage/locales/zh-CN.ts";
import lang_zhCN3 from "/app/src/pages/ArticleShowPage/locales/zh-CN.ts";
import lang_zhCN4 from "/app/src/pages/AttendanceRecordFormPage/locales/zh-CN.ts";
import lang_zhCN5 from "/app/src/pages/AttendanceRecordListPage/locales/zh-CN.ts";
import lang_zhCN6 from "/app/src/pages/AttendanceRecordLocationPage/locales/zh-CN.ts";
import lang_zhCN7 from "/app/src/pages/CompaniesMapPage/locales/zh-CN.ts";
import lang_zhCN8 from "/app/src/pages/CompanyDetailPage/locales/zh-CN.ts";
import lang_zhCN9 from "/app/src/pages/CompanyFormSelectPage/locales/zh-CN.ts";
import lang_zhCN10 from "/app/src/pages/CompanyManagePage/locales/zh-CN.ts";
import lang_zhCN11 from "/app/src/pages/CompanyScoreOperateRecordCreateRectificationRecordFormPage/locales/zh-CN.ts";
import lang_zhCN12 from "/app/src/pages/CompanyScoreOperateRecordListPage/locales/zh-CN.ts";
import lang_zhCN13 from "/app/src/pages/CompanySelectPage/locales/zh-CN.ts";
import lang_zhCN14 from "/app/src/pages/CompanyServiceFormPage/locales/zh-CN.ts";
import lang_zhCN15 from "/app/src/pages/CompanyServiceListPage/locales/zh-CN.ts";
import lang_zhCN16 from "/app/src/pages/CompanyStaffFormPage/locales/zh-CN.ts";
import lang_zhCN17 from "/app/src/pages/CompanyStaffListPage/locales/zh-CN.ts";
import lang_zhCN18 from "/app/src/pages/CompanyUpdatePage/locales/zh-CN.ts";
import lang_zhCN19 from "/app/src/pages/FeedbackRecordFormPage/locales/zh-CN.ts";
import lang_zhCN20 from "/app/src/pages/FeedbackRecordListPage/locales/zh-CN.ts";
import lang_zhCN21 from "/app/src/pages/IndexPage/JuvenilesBlockReportListPage/locales/zh-CN.ts";
import lang_zhCN22 from "/app/src/pages/IndexPage/locales/zh-CN.ts";
import lang_zhCN23 from "/app/src/pages/IotHardwareFormPage/locales/zh-CN.ts";
import lang_zhCN24 from "/app/src/pages/IotHardwareListPage/locales/zh-CN.ts";
import lang_zhCN25 from "/app/src/pages/JuvenilesBlockReportFormPage/locales/zh-CN.ts";
import lang_zhCN26 from "/app/src/pages/LicenseFormPage/locales/zh-CN.ts";
import lang_zhCN27 from "/app/src/pages/LicenseListPage/locales/zh-CN.ts";
import lang_zhCN28 from "/app/src/pages/MapSelectPage/locales/zh-CN.ts";
import lang_zhCN29 from "/app/src/pages/RectificationAndReportingPage/locales/zh-CN.ts";
import lang_zhCN30 from "/app/src/pages/RectificationRecordDetailPage/locales/zh-CN.ts";
import lang_zhCN31 from "/app/src/pages/RectificationRecordListPage/locales/zh-CN.ts";
import lang_zhCN32 from "/app/src/pages/ResultPage/locales/zh-CN.ts";
import lang_zhCN33 from "/app/src/pages/SelfAuditRecordListPage/locales/zh-CN.ts";
import lang_zhCN34 from "/app/src/pages/SelfAuditRecordNewPage/locales/zh-CN.ts";
import lang_zhCN35 from "/app/src/pages/SelfAuditRecordShowPage/locales/zh-CN.ts";
import lang_zhCN36 from "/app/src/pages/SelfAuditSettingListPage/locales/zh-CN.ts";
import lang_zhCN37 from "/app/src/pages/SignInPage/locales/zh-CN.ts";

export const localeInfo: {[key: string]: any} = {
  'en-US': {
    messages: {
      ...lang_enUS0,
    },
    locale: 'en-US',
    antd: {
      ...enUS0,
    },
    momentLocale: '',
  },
  'zh-CN': {
    messages: {
      ...lang_zhCN0,...lang_zhCN1,...lang_zhCN2,...lang_zhCN3,...lang_zhCN4,...lang_zhCN5,...lang_zhCN6,...lang_zhCN7,...lang_zhCN8,...lang_zhCN9,...lang_zhCN10,...lang_zhCN11,...lang_zhCN12,...lang_zhCN13,...lang_zhCN14,...lang_zhCN15,...lang_zhCN16,...lang_zhCN17,...lang_zhCN18,...lang_zhCN19,...lang_zhCN20,...lang_zhCN21,...lang_zhCN22,...lang_zhCN23,...lang_zhCN24,...lang_zhCN25,...lang_zhCN26,...lang_zhCN27,...lang_zhCN28,...lang_zhCN29,...lang_zhCN30,...lang_zhCN31,...lang_zhCN32,...lang_zhCN33,...lang_zhCN34,...lang_zhCN35,...lang_zhCN36,...lang_zhCN37,
    },
    locale: 'zh-CN',
    antd: {
      ...zhCN0,
    },
    momentLocale: 'zh-cn',
  },
};

/**
 * 增加一个新的国际化语言
 * @param name 语言的 key
 * @param messages 对应的枚举对象
 * @param extraLocale momentLocale, antd 国际化
 */
export const addLocale = (
  name: string,
  messages: Object,
  extraLocales: {
    momentLocale:string;
    antd:string
  },
) => {
  if (!name) {
    return;
  }
  // 可以合并
  const mergeMessages = localeInfo[name]?.messages
    ? Object.assign({}, localeInfo[name].messages, messages)
    : messages;


  const { momentLocale, antd } = extraLocales || {};
  const locale = name.split('-')?.join('-')
  localeInfo[name] = {
    messages: mergeMessages,
    locale,
    momentLocale: momentLocale,
    antd,
  };
   // 如果这是的 name 和当前的locale 相同需要重新设置一下，不然更新不了
  if (locale === getLocale()) {
    event.emit(LANG_CHANGE_EVENT, locale);
  }
};

/**
 * 获取当前的 intl 对象，可以在 node 中使用
 * @param locale 需要切换的语言类型
 * @param changeIntl 是否不使用 g_intl
 * @returns IntlShape
 */
export const getIntl = (locale?: string, changeIntl?: boolean) => {
  // 如果全局的 g_intl 存在，且不是 setIntl 调用
  if (g_intl && !changeIntl && !locale) {
    return g_intl;
  }
  // 如果存在于 localeInfo 中
  if (locale&&localeInfo[locale]) {
    return createIntl(localeInfo[locale]);
  }
  // 不存在需要一个报错提醒
  warning(
    !locale||!!localeInfo[locale],
    `The current popular language does not exist, please check the locales folder!`,
  );
  // 使用 zh-CN
  if (localeInfo["zh-CN"]) return createIntl(localeInfo["zh-CN"]);

  // 如果还没有，返回一个空的
  return createIntl({
    locale: "zh-CN",
    messages: {},
  });
};

/**
 * 切换全局的 intl 的设置
 * @param locale 语言的key
 */
export const setIntl = (locale: string) => {
  g_intl = getIntl(locale, true);
};

/**
 * 获取当前选择的语言
 * @returns string
 */
export const getLocale = () => {
  const runtimeLocale = plugin.applyPlugins({
    key: 'locale',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  // runtime getLocale for user define
  if (typeof runtimeLocale?.getLocale === 'function') {
    return runtimeLocale.getLocale();
  }
  // please clear localStorage if you change the baseSeparator config
  // because changing will break the app
  const lang =
    navigator.cookieEnabled && typeof localStorage !== 'undefined' && useLocalStorage
      ? window.localStorage.getItem('umi_locale')
      : '';
  // support baseNavigator, default true
  let browserLang;
  return lang || browserLang || "zh-CN";
};


/**
 * 获取当前选择的方向
 * @returns string
 */
export const getDirection = () => {
  const lang = getLocale();
  // array with all prefixs for rtl langueges ex: ar-EG , he-IL
  const rtlLangs = ['he', 'ar', 'fa', 'ku']
  const direction =  rtlLangs.filter(lng => lang.startsWith(lng)).length ? 'rtl' : 'ltr';
  return direction;
};

/**
 * 切换语言
 * @param lang 语言的 key
 * @param realReload 是否刷新页面，默认刷新
 * @returns string
 */
export const setLocale = (lang: string, realReload: boolean = true) => {
  const runtimeLocale = plugin.applyPlugins({
    key: 'locale',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });

  const updater = () => {
    if (getLocale() !== lang) {
      if (navigator.cookieEnabled && typeof window.localStorage !== 'undefined' && useLocalStorage) {
        window.localStorage.setItem('umi_locale', lang || '');
      }
      setIntl(lang);
      if (realReload) {
        window.location.reload();
      } else {
        event.emit(LANG_CHANGE_EVENT, lang);
        // chrome 不支持这个事件。所以人肉触发一下
        if (window.dispatchEvent) {
          const event = new Event('languagechange');
          window.dispatchEvent(event);
        }
      }
    }
  }

  if (typeof runtimeLocale?.setLocale === 'function') {
    runtimeLocale.setLocale({
      lang,
      realReload,
      updater: updater,
    });
    return;
  }

  updater();
};

let firstWaring = true;

/**
 * intl.formatMessage 的语法糖
 * @deprecated 使用此 api 会造成切换语言的时候无法自动刷新，请使用 useIntl 或 injectIntl
 * @param descriptor { id : string, defaultMessage : string }
 * @param values { [key:string] : string }
 * @returns string
 */
export const formatMessage: IntlShape['formatMessage'] = (
  descriptor: MessageDescriptor,
  values: any,
) => {
  if (firstWaring) {
    warning(
      false,
      `Using this API will cause automatic refresh when switching languages, please use useIntl or injectIntl.

使用此 api 会造成切换语言的时候无法自动刷新，请使用 useIntl 或 injectIntl。

http://j.mp/37Fkd5Q
      `,
    );
    firstWaring = false;
  }
  return g_intl.formatMessage(descriptor, values);
};

/**
 * 获取语言列表
 * @returns string[]
 */
export const getAllLocales = () => Object.keys(localeInfo);
